module.exports = __webpack_public_path__ + "static/media/sc_20_i.003a43cf.png";